import request from '@/utils/request';
export function transformItem2Dto(item) {
  const dto = {
    userID: item.id,
    ...item
  };
  delete dto.id;
  const roles = [];
  if (item.roles) {
    item.roles.forEach(role => {
      const roleDto = {
        roleID: role.id,
        ...role
      };
      delete roleDto.id;
      roles.push(roleDto);
    });
  }
  dto.roles = roles;

  return dto;
}

function transformDto2Item(dto) {
  const item = {
    id: dto.userID,
    ...dto
  };
  delete item.userID;
  const roles = [];
  if (dto.roles) {
    dto.roles.forEach(roleDto => {
      const role = {
        id: roleDto.roleID,
        ...roleDto
      };
      delete role.roleID;
      roles.push(role);
    });
  }
  item.roles = roles;
  return item;
}

function apiFetchList(params) {
  return request({
    method: 'get',
    params: params && params.query,
    url: '/domain/' + params.domainID + '/users'
  });
}
export const apiOverrides = { transformItem2Dto, transformDto2Item, apiFetchList };

function apiSelfUpdate(user) {
  return request({
    data: transformItem2Dto(user),
    method: 'put',
    url: '/user'
  });
}
function apiFetchUser(id, withPermissions) {
  return request({
    method: 'get',
    params: {
      withPermissions: withPermissions
    },
    url: '/user/' + id.toString()
  });
}
function apiAdminUpdate(user) {
  return request({
    data: transformItem2Dto(user),
    method: 'put',
    url: '/user/' + user.id.toString() + '/roles'
  });
}
export const storeExtensions = {
  actions: {
    update({ dispatch }, user) {
      return apiAdminUpdate(user);
    },
    updateSelf({ dispatch }, user) {
      return apiSelfUpdate(user);
    },
    fetchUser({ dispatch }, { id, withPermissions } = {}) {
      return apiFetchUser(id, withPermissions);
    }
  }
};
